"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IntradayRow = void 0;
class IntradayRow {
    constructor(obj) {
        // Take in an object, and assign every property from that
        // object onto this newly created object.
        for (const prop in obj) {
            this[prop] = obj[prop];
        }
    }
}
exports.IntradayRow = IntradayRow;
//# sourceMappingURL=IntradayRow.js.map